import React from 'react';
import { APP_NAME } from '../constants/constants';

export function AppNameElement() {
  return <span>{APP_NAME}</span>;
}
